import api from "./Api.js";

export default {
	list(params) {
		return api().get(`/lms-types`, {
			params: params,
		});
	},
};
